import { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import { SubscriptionAddons } from "@dashboard/shared/subscription/SubscriptionAddons";
import { SubscriptionLimits } from "@dashboard/shared/subscription/SubscriptionLimits";
import { Box, Theme } from "@mui/material";

import { PaneElement } from "../../shared/PaneElement";

import { ChangeLimitsModal } from "./ChangeLimitsModal";

const useStyles = makeStyles()((muiTheme: Theme) => ({
    emptyBox: {
        height: "100vh",
        margin: 0,
    },
    gridContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: muiTheme.spacing(2),
    },
}));

const LimitsTab = (props: {
    clientFeatures: API.Feature[] | null;
    clientId?: number;
    onAddonToggle?: (limitType: string, newValue: number) => void;
}) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["common", "pages"]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalOpenCount, setModalOpenCount] = useState(0);
    const [selectedLimitType, setSelectedLimitType] = useState<string>("");
    const [selectedLimitValue, setSelectedLimitValue] = useState<number>(0);

    const { clientFeatures, clientId, onAddonToggle } = props;

    const handleTileClick = (limitType: string, currentLimit: number) => {
        setSelectedLimitType(limitType);
        setSelectedLimitValue(currentLimit);
        setModalOpenCount((count) => count + 1);
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };

    const handleToggle = (limitType: string, newValue: number) => {
        onAddonToggle?.(limitType, newValue);
    };

    if (!clientFeatures) {
        return (
            <PaneElement.Container>
                <PaneElement.Header>{t("common:limits.subscriptionLimits")}</PaneElement.Header>
                <Box className={classes.emptyBox} />
            </PaneElement.Container>
        );
    }

    return (
        <PaneElement.Container>
            <SubscriptionAddons features={clientFeatures || []} editable={true} onToggle={handleToggle} variant="pane" />
            <SubscriptionLimits features={clientFeatures || []} editable={true} onLimitClick={handleTileClick} variant="pane" />

            <ChangeLimitsModal
                key={modalOpenCount}
                open={modalOpen}
                onClose={handleModalClose}
                initialLimitType={selectedLimitType}
                initialValue={selectedLimitValue}
                clientId={clientId}
            />
        </PaneElement.Container>
    );
};

export default LimitsTab;
